<form [formGroup]="searchForm">
  <!-- Responsive Grid - ottimizzato per layout orizzontale -->
  <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-4 xl:tw-grid-cols-5 tw-gap-4 tw-items-end">

    <!-- Device Serial - colonna più ampia sui grandi schermi -->
    <div class="sm:tw-col-span-1 lg:tw-col-span-2">
      <mat-form-field class="custom-mat-form-field w-full custom-border-bottom">
        <input
          matInput
          formControlName="deviceSerial"
          autocomplete="off"
          [placeholder]="labels.searchPlaceholder || 'Device Serial'">
        <mat-icon
          class="s-6 text-grey-400"
          matSuffix>search</mat-icon>
        <mat-error *ngIf="deviceSerialError">{{ deviceSerialError }}</mat-error>
      </mat-form-field>
    </div>

    <!-- Date From -->
    <div>
      <mat-form-field class="custom-mat-form-field w-full custom-border-bottom">
        <input
          matInput
          formControlName="dateFrom"
          [placeholder]="labels.dateFrom || 'From Date'"
          [matDatepicker]="fromPicker">
        <mat-datepicker-toggle
          matSuffix
          [for]="fromPicker">
        </mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Date To -->
    <div>
      <mat-form-field class="custom-mat-form-field w-full custom-border-bottom">
        <input
          matInput
          formControlName="dateTo"
          [placeholder]="labels.dateTo || 'To Date'"
          [matDatepicker]="toPicker">
        <mat-datepicker-toggle
          matSuffix
          [for]="toPicker">
        </mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Operator -->
    <div>
      <mat-form-field class="custom-mat-form-field w-full custom-border-bottom">
        <input
          matInput
          formControlName="operatorId"
          placeholder="Operator">
        <mat-icon
          class="s-6 text-grey-400"
          matSuffix>
          person
        </mat-icon>
      </mat-form-field>
    </div>

    <!-- Action Buttons -->
    <div class="tw-flex tw-gap-2 tw-justify-end xl:tw-justify-start">
      <button
        class="custom-mat-button-secondary custom-mat-button-border"
        mat-button
        type="button"
        (click)="onClear()">
        {{ labels.clear || 'Clear' }}
      </button>
      <button
        class="custom-mat-button-primary custom-mat-button-border"
        mat-button
        type="button"
        [disabled]="!searchForm.valid"
        (click)="onSearch()">
        {{ labels.search || 'Search' }}
      </button>
    </div>
  </div>

  <!-- Error Messages Row -->
  <div
    *ngIf="dateRangeError"
    class="tw-mt-2">
    <mat-error class="tw-text-sm">{{ dateRangeError }}</mat-error>
  </div>
</form>
